import { Component, Input } from '@angular/core';

export interface SectionFlowChartData {
  title: string;
  subtitle: string;
  img: string;
}

@Component({
  selector: 'fcp-section-flow-chart',
  templateUrl: 'section-flow-chart.component.html',
  styleUrls: ['./section-flow-chart.component.scss']
})

export class SectionFlowChartComponent {

  @Input() public flowChartData: Array<SectionFlowChartData>;

}
